/**
 * Classe para formatar o field do tipo milliseconds.
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */



Monet.Format = Monet.Format || {};
Monet.Format.MILLISECONDS = (function () {

    function MILLISECONDS(value) {

        Monet.Format.DATE.apply(this, arguments);

        this.value = value;

        this.formatToElapsedTime = function () {

            var timeFormatted = [];
            var seconds = Math.floor(this.value / 1000);
            var minutes = Math.floor(seconds / 60);
            var hour = Math.floor(minutes / 60);
            var totalOfMinutes = minutes % 60;
            var totalOfSeconds = seconds % 60;

            if (hour > 0) {
                timeFormatted.push(hour + Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.hourAbreviation"));
            }

            if (totalOfMinutes) {
                timeFormatted.push(totalOfMinutes + Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.minuteAbreviation"));
            }

            if (totalOfSeconds > 0) {
                timeFormatted.push(totalOfSeconds + Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.secondsAbreviation"));
            }

            this.value = timeFormatted.join(' ');

            return this;

        };

        this.toGrid = function () {

            this.formatToElapsedTime();

            return this;

        };

    }

    return MILLISECONDS;

}());
